import React from 'react';

const TymeLoader = ({ size = 'md', fullScreen = false, text = '' }) => {
  const sizes = {
    sm: { container: 'w-12 h-12', spinner: 'w-7 h-7' },
    md: { container: 'w-[72px] h-[72px]', spinner: 'w-11 h-11' },
    lg: { container: 'w-24 h-24', spinner: 'w-16 h-16' }
  };

  const containerClass = sizes[size]?.container || sizes.md.container;
  const spinnerClass = sizes[size]?.spinner || sizes.md.spinner;

  const loader = (
    <div className="flex flex-col items-center gap-3">
      <div 
        className={`${containerClass} inline-grid place-items-center rounded-[20px] relative`}
        style={{
          background: 'rgba(255,255,255,0.06)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.06)',
          backdropFilter: 'blur(10px)'
        }}
      >
        <svg 
          className={`${spinnerClass} z-10`}
          viewBox="0 0 44 44" 
          aria-label="Loading" 
          role="status"
        >
          <defs>
            <linearGradient id="tymeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#8B5CF6"/>
              <stop offset="100%" stopColor="#EC4899"/>
            </linearGradient>
          </defs>
          <g fill="none" strokeLinecap="round" strokeWidth="4">
            <circle cx="22" cy="22" r="18" stroke="rgba(255,255,255,0.10)"/>
            <circle 
              className="tyme-arc" 
              cx="22" 
              cy="22" 
              r="18" 
              stroke="url(#tymeGrad)"
              style={{
                strokeDasharray: '100 126',
                transformOrigin: '50% 50%',
                animation: 'tyme-spin 1.1s linear infinite, tyme-dash 1.6s ease-in-out infinite'
              }}
            />
          </g>
        </svg>
      </div>
      {text && (
        <p className="text-white/70 text-sm font-medium">{text}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-[#0b0b10]/80 backdrop-blur-sm flex items-center justify-center z-50">
        {loader}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      {loader}
    </div>
  );
};

export default TymeLoader;
